import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../../global/commonStyle';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;

const BottomContent = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;

const Box = styled.div`
  ${FlexBetween}
  padding: var(--space-12) var(--space-16);
  gap: var(--space-20);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const LeftContent = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const RightContent = styled.div`
  svg {
    cursor: pointer;
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
  }
`;

const Description = styled.div`
  ${AlignCenter}
  p {
    color: var(--text-secondary);
    ${Typography.body_md}
    margin:var(--space-0);
    a {
      color: var(--brand-primary);
      ${Typography.body_md}
      text-decoration: none;
    }
  }
`;
const Autotext = styled.div`
  ${AlignCenter}
`;

const Icon = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;
const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 483px;
  width: 100%;
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const Label = styled.div`
  padding: var(--space-2) var(--space-5);
  border-radius: var(--border-radius-6);
  border: 1px solid var(--neutral-secondary);
  background: var(--neutral-secondary);
  p {
    color: var(--text-secondary);
    ${Typography.body_sm}
    margin: var(--space-0);
    white-space: nowrap;
  }
`;

const TitleSection = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  h1 {
    color: var(--text-primary);
    ${Typography.body_lg_medium}
    margin: var(--space-0);
  }
`;

export {
  Autotext,
  BottomContent,
  Box,
  Content,
  Description,
  Icon,
  Label,
  LeftContent,
  RightContent,
  Text,
  TitleSection
};
